/* Mirumi theme behaviour: menu, search, gallery, quantity, AJAX add-to-cart, video, lightbox. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function toggle(el, open, trigger) {
    if (!el) return; el.classList.toggle('is-open', open); el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement; if (!t || !t.closest) return;
    var mo = t.closest('[data-gm-menu-open]'); if (mo) { toggle($('[data-gm-menu]'), true, mo); return; }
    if (t.closest('[data-gm-menu-close]')) { toggle($('[data-gm-menu]'), false, $('[data-gm-menu-open]')); return; }
    if (t.closest('[data-gm-search-open]')) { toggle($('[data-gm-search]'), true); setTimeout(function () { var i = $('[data-gm-search] input'); i && i.focus(); }, 50); return; }
    if (t.closest('[data-gm-search-close]') || t.classList.contains('gm-search')) { toggle($('[data-gm-search]'), false); return; }
    var pl = t.closest('[data-gm-video-play]');
    if (pl) { var box = pl.closest('[data-gm-video]'); var tpl = $('[data-gm-video-tpl]', box); if (tpl) { box.innerHTML = ''; box.appendChild(tpl.content.cloneNode(true)); var v = $('video', box); v && v.play && v.play().catch(function () {}); } return; }
    var z = t.closest('[data-gm-zoom]');
    if (z) { var lb = $('[data-gm-lightbox]'); $('img', lb).src = z.getAttribute('data-gm-zoom'); toggle(lb, true); return; }
    if (t.closest('[data-gm-lightbox-close]') || t.classList.contains('gm-lightbox')) { toggle($('[data-gm-lightbox]'), false); return; }
    var q = t.closest('[data-gm-qty]');
    if (q) { var inp = $('[data-gm-qty-input]'); var max = +inp.max || 99; var n = Math.max(1, Math.min(max, (+inp.value || 1) + (+q.getAttribute('data-gm-qty')))); inp.value = n; syncQty(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { toggle($('[data-gm-menu]'), false); toggle($('[data-gm-search]'), false); toggle($('[data-gm-lightbox]'), false); } });
  function syncQty() { var inp = $('[data-gm-qty-input]'); if (!inp) return; var minus = $('[data-gm-qty="-1"]'), plus = $('[data-gm-qty="1"]'); if (minus) minus.disabled = (+inp.value) <= 1; if (plus) plus.disabled = (+inp.value) >= (+inp.max || 99); }
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-gm-qty-input]')) syncQty(); });

  /* mobile gallery dots */
  function initGallery() {
    var g = $('[data-gm-gallery]'), dots = $('[data-gm-dots]'); if (!g || !dots) return;
    var items = $$('li', g); if (items.length < 2) return;
    dots.innerHTML = items.map(function (_, i) { return '<button type="button" class="gm-dot' + (i === 0 ? ' is-on' : '') + '" aria-label="Go to image ' + (i + 1) + '" data-i="' + i + '"></button>'; }).join('');
    dots.removeAttribute('aria-hidden');
    dots.addEventListener('click', function (e) { var b = e.target.closest('.gm-dot'); if (!b) return; g.scrollTo({ left: g.clientWidth * (+b.dataset.i), behavior: 'smooth' }); });
    g.addEventListener('scroll', function () { var i = Math.round(g.scrollLeft / g.clientWidth); $$('.gm-dot', dots).forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }, { passive: true });
  }

  /* AJAX add to cart using the theme's cart drawer */
  function initForm() {
    var form = $('[data-gm-form]'); if (!form) return;
    form.addEventListener('submit', function (e) {
      var btn = $('[data-gm-atc]', form); if (!btn || btn.disabled) { e.preventDefault(); return; }
      var cart = $('cart-drawer'); if (!cart || !window.fetch) return; // fall back to normal form post
      e.preventDefault();
      var msg = $('[data-gm-msg]', form); msg.textContent = ''; btn.disabled = true;
      var fd = new FormData(form);
      var body = { items: [{ id: +fd.get('id'), quantity: +fd.get('quantity') || 1 }] };
      if (cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) { msg.textContent = res.j.description || res.j.message || 'Could not add to cart.'; return; }
          cart.renderContents(res.j); cart.classList.remove('is-empty');
        })
        .catch(function () { msg.textContent = 'Something went wrong. Please try again.'; })
        .then(function () { btn.disabled = false; });
    });
    syncQty();
  }
  function boot() { initGallery(); initForm(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
